export { Card } from "./component";
export type { CardProps, CardStyleProps } from "./types";
